import * as angular from "angular";
import {IController} from "angular";
import {RuleActionModel} from "../../models/rule-action.model";
import {RuleActionData} from "../../models/rule-action-data";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {RuleFilterEntityType} from "../../types/rule-filter-entity.type";
import {RuleFilterDataType} from "../../types/rule-filter-data.type";
import * as _ from "lodash";
import {RuleConditionStage} from "../../models/rule-condition-stage.model";
import {ConditionModel} from "../../models/condition.model";
import {RuleStageCondition} from "../../models/rule-stage-condition.model";
import {FulfillmentLineType} from "../../../oms/types/fulfillment-line.type";
import {AgentStatusType} from "../../../agents/types/agentStatus.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class RuleControllerActionComponent implements IController {

  action: RuleActionModel;
  actionOptions: RuleActionModel[];
  generalFilters: RuleStageCondition[];
  controllerConditions: ConditionModel[];

  public actionsMap: {} = {};
  public notMandatoryDataInputs: RuleActionData[] = [];
  public notMandatoryDataInputsName: string[] = [];
  public actionDataMap: {} = {};
  public siteInfo: any;
  public ruleFilterEntityType: typeof RuleFilterEntityType = RuleFilterEntityType;
  public ruleFilterDataType: typeof RuleFilterDataType = RuleFilterDataType;
  public bringozSelectParams: any = {};

  constructor(private siteContextService: SiteContextService,
              private splitService: SplitService) {
  }

  $onInit() {
    this.siteInfo = this.siteContextService.getSiteInfo();
    if (this.actionOptions) {
      this._initActionsMap();

      if (this.action.actionType) {
        const selectedActionOption = this.actionOptions.find(a => a.actionType === this.action.actionType);
        this._initSelectedActionDataInputs(selectedActionOption);
      }
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.action && !changes.action.isFirstChange()) {
      if (this.action.actionType) {
        const selectedActionOption: RuleActionModel = this.actionOptions.find(a => a.actionType === this.action.actionType);
        this._initSelectedActionDataInputs(selectedActionOption);
      }
    }

    if (changes.actionOptions && !changes.actionOptions.isFirstChange()) {
      if (this.actionOptions) {
        this._initActionsMap();
        if (this.action.actionType) {
          const selectedActionOption = this.actionOptions.find(a => a.actionType === this.action.actionType);
          this._initSelectedActionDataInputs(selectedActionOption);
        }
      }
    }

    if (changes.generalFilters || changes.controllerConditions) {
      this.initBringozSelectParams();
    }

  }

  private initBringozSelectParams() {
    this.bringozSelectParams = {
      accountIds: []
    };
    const accountGeneralCondition = this.generalFilters?.find(f => f.fieldName === 'accountId');
    const accountControllerCondition = this.controllerConditions?.find(f => f.fieldName === 'accountId');

    if (!!accountGeneralCondition && accountGeneralCondition.operator === 'in' && !!accountGeneralCondition?.value) {
      this.bringozSelectParams.accountIds = _.uniq(this.bringozSelectParams.accountIds.concat(accountGeneralCondition.value));
    }

    if (!!accountControllerCondition && accountControllerCondition.operator === 'in' && !!accountControllerCondition?.value) {
      this.bringozSelectParams.accountIds = _.uniq(this.bringozSelectParams.accountIds.concat(accountControllerCondition.value));
    }

  }

  onSelect(value: any, dataItem: RuleActionData): void {
    dataItem.value = value;
  }

  onChipsChange(items: string[], dataItem: RuleActionData): void {
    dataItem.value = items;
  }

  onSelectAction(action: RuleActionModel) {
    this.action.dataList = [];
    this.notMandatoryDataInputsName = [];
    this.notMandatoryDataInputs = [];
    this._initSelectedActionDataInputs(action);
  }

  onDateChange(date: number, dataItem: RuleActionData) {
    dataItem.value = date;
  }

  onSelectValueChange(dataItem: RuleActionData, value) {
    dataItem.value = value;
  }

  onSelectValuesChange(dataItem: RuleActionData, values) {
    dataItem.values = values;
  }


  onSelectNotMandatoryDataInput(items: string[]) {
    const selectedNotMandatoryDataInputs: RuleActionData[] = this.notMandatoryDataInputs.filter(i => items.includes(i.fieldName));

    selectedNotMandatoryDataInputs.forEach((i: RuleActionData) => {
      const ruleActionData = new RuleActionData(i);
      this.action.dataList.push({
        fieldName: ruleActionData.fieldName,
        entity: ruleActionData.entity,
        id: ruleActionData.id
      })
    });

    this.notMandatoryDataInputs = this.notMandatoryDataInputs.filter((i: RuleActionData) => !items.includes(i.fieldName));

    this.notMandatoryDataInputsName = this.notMandatoryDataInputs.map((i: RuleActionData) => i.fieldName);
  }

  onAddObjectListValue(dataListId: string): void {
    const dataListCopy = angular.copy(this.action.dataList);

    const dataListItemIndex = this.action.dataList.findIndex(dl => dl.id === dataListId);
    if (!dataListCopy[dataListItemIndex].value) {
      dataListCopy[dataListItemIndex].value = [];
    }
    const dataListItemEntity = {};

    this.actionDataMap[dataListId].dataList.forEach(dl => {
      dataListItemEntity[dl.fieldName] = undefined;
    })

    dataListCopy[dataListItemIndex].value.push(dataListItemEntity);
    this.action.dataList = dataListCopy;
  }

  onRemoveObjectListValue(dataListId: string, objectListValueIndex: number) {
    const dataListCopy = angular.copy(this.action.dataList);
    const dataListItemIndex = this.action.dataList.findIndex(dl => dl.id === dataListId);
    dataListCopy[dataListItemIndex].value.splice(objectListValueIndex, 1);
    this.action.dataList = dataListCopy;
  }

  private _initSelectedActionDataInputs(selectedActionOption: RuleActionModel): void {

    this._initActionDataInputsMap(selectedActionOption);

    selectedActionOption.dataList?.forEach((i: RuleActionData): void => {
      const ruleActionData = new RuleActionData(i);

      if (!this.action.dataList.map(d => d.fieldName).includes(ruleActionData.fieldName)) {

        if (ruleActionData.mandatory) {
          this.action.dataList.push({
            fieldName: ruleActionData.fieldName,
            entity: ruleActionData.entity,
            id: ruleActionData.id
          })
        } else {
          this.notMandatoryDataInputs.push(ruleActionData);
        }

      } else {
        const action = this.action.dataList.find((d: RuleActionData) => {
          if (i.entity) {
            return i.entity === d.entity && i.fieldName === d.fieldName;
          } else {
            return i.fieldName === d.fieldName;
          }
        })
        const actionIndex = this.action.dataList.findIndex((d: RuleActionData) => {
          if (i.entity) {
            return i.entity === d.entity && i.fieldName === d.fieldName;
          } else {
            return i.fieldName === d.fieldName;
          }
        })
        if (i.type === this.ruleFilterDataType.ObjectList) {
          const subDataListFieldNames: string[] = i.dataList.map(dl => dl.fieldName);
          action.value.forEach(v => {
            const valueFieldNames: string[] = Object.keys(v);
            const fieldNamesDifference: string[] = _.difference(subDataListFieldNames, valueFieldNames);
            fieldNamesDifference.forEach(fn => {
              v[fn] = undefined;
            });
          })
        }
        const newAction = {
          fieldName: ruleActionData.fieldName,
          entity: ruleActionData.entity,
          id: ruleActionData.id,
          value: action.value,
          values: action.values
        }
        this.action.dataList.splice(actionIndex, 1);
        this.action.dataList.push(newAction);
      }

    })

    this.notMandatoryDataInputsName = this.notMandatoryDataInputs.map((i: RuleActionData) => i.fieldName);

  }

  private _initActionsMap() {
    this.actionOptions.forEach((a: RuleActionModel) => {
      this.actionsMap[a.actionType] = a;
    })
  }

  private _initActionDataInputsMap(selectedActionOption: RuleActionModel) {
    selectedActionOption.dataList?.forEach((i: RuleActionData) => {
      const ruleActionData = new RuleActionData(i);
      if (i.entity === 'ProviderType') {
        ruleActionData.values = this.siteInfo.supportedThreePlProviders;
      }
      if (i.fieldName === 'lineType') {
        ruleActionData.values = Object.values(FulfillmentLineType);
      }
      if (i.entityTypeValue === 'AgentStatus') {
        ruleActionData.values = Object.values(AgentStatusType);
      }
      if (i.entityTypeValue === 'CustomizedServiceField') {
        const customFields = this.splitService.getCustomFields();
        ruleActionData.values = customFields;
        ruleActionData.options = customFields;
      }

      this.actionDataMap[ruleActionData.id] = ruleActionData;
    })
  }

}


angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleControllerAction', {
    bindings: {
      action: '<',
      actionOptions: '<?',
      generalFilters: '<?',
      controllerConditions: '<?'
    },
    template: require('./rule-controller-action.html').default,
    controller: RuleControllerActionComponent
  });

